import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs';
import { LogService } from '../services/log.service';
import { LogTrustPrevRequest } from '../models/logTrustPrevRequest.model';

@Injectable()

export class JwtInterceptor implements HttpInterceptor {

    logTrustPrevRequest: LogTrustPrevRequest = new LogTrustPrevRequest();
    loginAccount: string;
    constructor(private authenticationService: AuthenticationService,
        private logService: LogService) {
        this.loginAccount = localStorage.getItem('usuarioLogado');
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     
        const currentToken = this.authenticationService.currentTokenValue;

        if (currentToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentToken}`
                }

            });


            this.logTrustPrevRequest.idLogin = this.loginAccount;
            this.logTrustPrevRequest.idEvento = request.method === 'POST' ? 'P' : 'G';


            const separado = request.url.split('/');
            const ultimasTres = separado.slice(-3);
            const resultado = ultimasTres.join('/');



            this.logTrustPrevRequest.idClass = resultado;
            this.logService.saveLog(this.logTrustPrevRequest).subscribe(retorno => {

            });
        }

        return next.handle(request)

    }

}